import React from 'react';
import { Container } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import PacienteForm from '../components/PacienteForm';

export default function CreatePacientePage() {
  return (
    <DashboardLayout>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <PacienteForm />
      </Container>
    </DashboardLayout>
  );
}
